const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise = null;

function loadScript() {
  if (window.grecaptcha) return Promise.resolve(true);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

/**
 * Token reCAPTCHA v3 (invisibile) per un'azione, o null se la Site Key non
 * è configurata (REACT_APP_RECAPTCHA_SITE_KEY vuota) o il caricamento
 * fallisce — in quel caso il backend fa comunque no-op (vedi Recaptcha.php
 * nel kernel), coerente col fallback lato server.
 */
export async function getRecaptchaToken(action) {
  if (!SITE_KEY) return null;
  const loaded = await loadScript();
  if (!loaded || !window.grecaptcha) return null;
  return new Promise((resolve) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action })
        .then(resolve)
        .catch(() => resolve(null));
    });
  });
}
